import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import Header from "../../../components/Header.vue";
// import moment from "moment";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)
// import moment from 'moment'

export default {
    components: {
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin
    },
    data: function () {
        return {
            pageTitle: "Liste des tresoreries",
            initialPage: parseInt(this.$route.query.page) > 0 ? parseInt(this.$route.query.page) : 1,
            dateOptions: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
            vuetable: {
                moreParams: {
                    critere_date: '',
                    date_debut: '',
                    date_fin: '',
                    is_bl: true,
                },
                fields: [
                    // {
                    //     name: VuetableFieldCheckbox,
                    //     titleClass: 'text-center',
                    //     dataClass: 'text-center'
                    // },
                    {
                        name: 'date_enlevement_formatted',
                        title: 'Date d\'enlèvement',
                        sortField: 'date_enlevement_formatted',
                        dataClass: 'text-left',
                        width: '150px'
                    },
                    {
                        name: 'nom_navire',
                        title: 'NAVIRE',
                        sortField: 'nom_navire',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'total_voyage',
                        title: 'Total Voyage',
                        sortField: 'total_voyage',
                        dataClass: 'text-right text-bold',
                        titleClass: "text-right",
                        width: "120px"
                    },
                    {
                        name: 'total_qte_t',
                        title: 'QteD/T',
                        sortField: 'total_qte_t',
                        dataClass: 'text-right text-bold',
                        titleClass: "text-right",
                        width: "120px"
                    },
                    {
                        name: 'total_nbre_sac',
                        title: 'Nbre Sac',
                        sortField: 'total_nbre_sac',
                        dataClass: 'text-right text-bold',
                        titleClass: "text-right",
                        width: "120px"
                    },
                    {
                        name: 'total_nbre_big_bag',
                        title: 'Big Bag',
                        sortField: 'total_nbre_big_bag',
                        dataClass: 'text-right text-bold',
                        titleClass: "text-right",
                        width: "120px"
                    },

                    {
                        name: 'actions',
                        title: '-',
                        titleClass: 'text-center column_fixed-header',
                        width: "80px",
                        dataClass: "text-center column_fixed"
                    }

                ],
                sortOrder: [
                    {field: 'date_enlevement', direction: 'desc'}
                ],
                css: {
                    table: {
                        // tableClass: 'table table-striped table-bordered table-hovered',
                        tableClass: 'table-responsive text-nowrap w-100 d-block d-md-table table table-bordered table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'fas fa-arrow-up fa-sm',
                        descendingIcon: 'fas fa-arrow-down fa-sm',
                        handleIcon: 'fas fa-bars fa-sm',
                    },
                    pagination: {
                        infoClass: 'pull-left ',
                        wrapperClass: 'vuetable-pagination text-center',
                        activeClass: 'btn-secondary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        },
                    }
                },
            },
            exportexcel: {
                json_fields: {
                    'Nom de la Tresorerie': 'libelle_ecoterme',
                    'Type de la Tresorerie': 'type_tresorerie',
                    'Solde': 'solde',
                    'Nom du compte': 'nom_compte',
                    'Numero du compte': 'numero_compte',
                    'BIC': 'bic',
                    'IBAN': 'iban',
                    'BANQUE Correspondante': 'banque_correspondante',
                    'Code swift': 'code_swift',
                    'Utilisateur associé': 'nom'

                },
                json_data: [],
                json_meta: [
                    [{
                        'key': 'charset',
                        'value': 'utf-8'
                    }]
                ],
            },
            motCle: "",
            crudform: {
                id: "",
                id_dossier: "",
                date_enlevement: '',
                date_enlevement_formatted: '',
                etat_suppression: '',
                nom_navire: '',
                id_navire: '',
                date_arriver: '',
            },

            btn_submit: false,
            criteriacol: '',
            filtre_etat: '',
            filtre: {
                date_debut: '',
                date_fin: '',
            },
            LIST_DOSSIER: [],
        }
    },

    methods: {
        onSearch(searchQuery) {
            this.fetchDossier(searchQuery);
        },
        fetchDossier(search) {
            let formulaire = new FormData();
            formulaire.append('search', search)
            axios.post(this.BASE_URL + "/dossier/getdossier/", formulaire).then(response => {
                this.LIST_DOSSIER = response.data;
            });
        },

        onRowClass(dataItem, index) {
            if (index == "") console.log("");
            return (parseFloat(dataItem.etat_dossier) > 0 && parseFloat(dataItem.total_solde) < 0) ? 'bg_cloturer-danger' : (parseFloat(dataItem.etat_dossier) > 0 && parseFloat(dataItem.total_solde) >= 0) ? 'bg_cloturer' : (parseFloat(dataItem.total_solde) < 0) ? 'text-danger' : '';
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.syncFiltersToUrl(paginationData.current_page);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        editRow(rowData) {
            axios.post(this.BASE_URL + "/suivieenlevement/get/"+rowData.id).then(response => {
                this.crudform= response.data.suivie[0];
                this.LIST_DOSSIER = response.data.liste_dossier;
                this.openModal();
            });
        },

        gotoDetails(rowData) {
            this.$router.push("/suivieenlevement/detail/" + rowData.id);
        },

        async printElementDetails(rowData) {
            try {
                this.$parent.showLoading = true;

                let formulaire = new FormData();
                formulaire.append('id_suivie_enlevement', rowData.id);

                const pdfResponse = await axios.post(
                    this.BASE_URL + "/suivieenlevementdetail/printelement",
                    formulaire
                );

                if (pdfResponse.data.success === true) {
                    window.open(pdfResponse.data.file_url, '_blank');
                } else {
                    Vue.$toast.open({
                        message: pdfResponse.data.message || 'Erreur lors de la génération du PDF.',
                        type: pdfResponse.data.success === false ? 'warning' : 'error',
                        position: 'top-right'
                    });
                }

            } catch (err) {
                console.error(err);
                Vue.$toast.open({
                    message: 'Une erreur est survenue.',
                    type: 'error',
                    position: 'top-right'
                });
            } finally {
                this.$parent.showLoading = false;
            }
        },

        async exportExcelDetails(rowData) {
            try {
                this.$parent.showLoading = true;

                let formulaire = new FormData();
                formulaire.append('id_suivie_enlevement', rowData.id);

                const excelResponse = await axios.post(
                    this.BASE_URL + "/suivieenlevementdetail/exportExcel",
                    formulaire
                );

                if (excelResponse.data.success === true) {
                    window.open(excelResponse.data.file_url, '_blank');
                } else {
                    Vue.$toast.open({
                        message: excelResponse.data.message || 'Erreur lors de la génération du fichier Excel.',
                        type: excelResponse.data.success === false ? 'warning' : 'error',
                        position: 'top-right'
                    });
                }

            } catch (err) {
                console.error(err);
                Vue.$toast.open({
                    message: 'Une erreur est survenue.',
                    type: 'error',
                    position: 'top-right'
                });
            } finally {
                this.$parent.showLoading = false;
            }
        },

        deleteRow(rowData) {
            //alert("You clicked delete on" + JSON.stringify(rowData));
            var that = this;
            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer cette ligne?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Supprimer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        axios.post(that.BASE_URL + "/suivieenlevement/deletebyid/" + rowData.id).then(function (response) {
                            console.log(response);
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log(response.data.message);
                                that.setFilter();
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })

        },



        onLoading() {
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            console.log('loaded! .. hide your spinner here');
        },
        applyFiltersToParams() {
            this.vuetable.moreParams.filter = this.motCle;
            this.vuetable.moreParams.criteriacol = this.criteriacol;
            this.vuetable.moreParams.filtre_etat = this.filtre_etat;

            this.vuetable.moreParams.critere_date = (this.filtre.date_fin != "" || this.filtre.date_debut != "") ? "date_enlevement" : "";
            this.vuetable.moreParams.date_fin = (this.filtre.date_fin != "") ? this.filtre.date_fin : "";
            this.vuetable.moreParams.date_debut = (this.filtre.date_debut != "") ? this.filtre.date_debut : "";
        },
        syncFiltersToUrl(currentPage) {
            const query = {};
            if (this.motCle !== "") query.filter = this.motCle;
            if (this.criteriacol !== "") query.criteriacol = this.criteriacol;
            if (this.filtre_etat !== "") query.filtre_etat = this.filtre_etat;
            if (this.filtre.date_debut !== "") query.date_debut = this.filtre.date_debut;
            if (this.filtre.date_fin !== "") query.date_fin = this.filtre.date_fin;
            if (parseInt(currentPage) > 1) query.page = String(currentPage);

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({ query }).catch(() => {});
            }
        },
        setFilter() {
            this.applyFiltersToParams();

            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        resetFilter() {
            this.motCle = "";
            this.criteriacol = "";
            this.filtre_etat = "";
            this.filtre = {
                date_debut: '',
                date_fin: '',
            }

            this.setFilter();
        },

        addData(){
            this.crudform= {
                id: "",
                id_dossier: "",
                date_enlevement: '',
                date_enlevement_formatted: '',
                etat_suppression: '',
                nom_navire: '',
                id_navire: '',
                date_arriver: '',
            };
            this.openModal();
        },
        openModal() {
            this.$bvModal.show("crudmodal");
        },
        closeModal() {
            this.$bvModal.hide("crudmodal");
        },


        onSubmit() {
            var that = this;

            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment continuer l\'enregistrement?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Continuer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        var link = '';
                        that.btn_submit = true;

                        link = that.BASE_URL + "/suivieenlevement/savesuivieenlevement";

                        axios.post(link, $("#formulaire").serialize()).then(function (response) {
                            console.log(response);
                            that.btn_submit = false;
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log("Enregistrement effectué avec succès!");
                                that.closeModal();
                                that.setFilter();
                                Vue.$toast.open({
                                    message: 'Enregistrement effectué avec succès!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                });
        },


    },

    created: function () {
        this.$emit('change-page', this.pageTitle);
        const query = this.$route.query;
        this.motCle = query.filter || "";
        this.criteriacol = query.criteriacol || "";
        this.filtre_etat = query.filtre_etat || "";
        this.filtre = {
            date_debut: query.date_debut || "",
            date_fin: query.date_fin || "",
        };
        this.applyFiltersToParams();
    },
    mounted: function () {
        this.fetchDossier();
    }
}
